import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GetGroupListUseCaseInterface } from 'domain/usecases';
import { IGroupsListFilters } from 'presentation/app/modules/Groups/models/groups-list-filters';

interface IGroupsListState {
  groupsListData: GetGroupListUseCaseInterface.Result;
  groupsListFilters: IGroupsListFilters;
}

interface IPayloadGroupsList
  extends PayloadAction<GetGroupListUseCaseInterface.Result> {}

interface IPayloadGroupsListFilters extends PayloadAction<IGroupsListFilters> {}

const initialState: IGroupsListState = {
  groupsListData: null,
  groupsListFilters: null,
};

export const GroupListSlice = createSlice({
  name: 'group-list',
  initialState,
  reducers: {
    loadGroupList: (state, action: IPayloadGroupsList) => {
      state.groupsListData = action.payload;
    },
    clearGroupList: (state) => {
      state.groupsListData = null;
    },
    loadGroupsListFilters: (state, action: IPayloadGroupsListFilters) => {
      state.groupsListFilters = action.payload;
    },
    clearGroupsListFilters: (state) => {
      state.groupsListFilters = null;
    },
  },
});

export const {
  loadGroupList,
  clearGroupList,
  loadGroupsListFilters,
  clearGroupsListFilters,
} = GroupListSlice.actions;

export default GroupListSlice.reducer;
